import { baseAxios, handleError } from 'api';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import useCredentials from 'api/hook/useCredentials';

export function useUpdateUserCredential(id) {
  const authAxios = useCredentials();

  return useMutation({
    /** @param {{username, newPassword}} */
    mutationFn: (data) =>
      baseAxios(authAxios, {
        url: 'auth/fore_pwd',
        method: 'post',
        data,
      }),
    onError: handleError,
  });
}

export function useUpdateUser(id) {
  const authAxios = useCredentials();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data) =>
      baseAxios(authAxios, {
        url: 'admin/user/' + id,
        method: 'put',
        data,
      }),
    onError: handleError,
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['user', id] });
    },
  });
}
